import PriceWithCurrency from "@/components/Helpers/PriceWithCurrency";
import { useRouter } from "next/router";
// import Installments from "./Installments";

const PriceV2 = ({
  discount,
  originalPrice,
  specialPrice,
  fromInfo = true,
  // fromProductCard = false,
  // priceMonthly,
}) => {
  const { locale } = useRouter();
  return (
    <div
      dir={locale == "en" ? "ltr" : "rtl"}
      className={`flex justify-between items-center w-full ${
        !fromInfo && "my-1"
      }`}
    >
      <div className="flex flex-wrap gap-1 justify-between items-center text-xs">
        {discount > 0 && (
          <div
            className={`${
              fromInfo ? "text-[12px]" : "text-[10px]"
            } line-through flex items-center gap-1 font-bold text-[#B3B3B3]`}
          >
            <PriceWithCurrency
              amount={
                fromInfo
                  ? Math.round(originalPrice)?.toLocaleString()
                  : originalPrice
              }
              iconClassName="size-3"
              className="gap-1"
            />
          </div>
        )}
        <div className={`flex items-center gap-1 font-semibold text-lg`}>
          <PriceWithCurrency
            amount={
              fromInfo
                ? Math.round(specialPrice || originalPrice)?.toLocaleString()
                : specialPrice || originalPrice
            }
            iconClassName="size-4"
            className="gap-1"
          />
        </div>
      </div>

      {/* {!fromInfo && (
        <Installments
          {...{
            fromInfo,
            fromProductCard,
            specialPrice,
            originalPrice,
            priceMonthly,
            locale,
          }}
        />
      )} */}
    </div>
  );
};

export default PriceV2;
